<template>
     <v-row>
      <label class="input-text-size pa-2" style="color: red;">Proceed with caution.
        This will change the mailing address of every
        record in the picklist. Click Cancel if you do not wish to continue.</label>
      <!-- These two are labelled "In Care of" but bound to name1/name2; the backend
           (pickListBulkAddressChange) is what remaps them onto inCareOf1/inCareOf2, and it
           drops them when the county setting is on. Locked here to match. -->
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0"
        label="In Care of 1" v-model="editedItem.name1"
        v-uppercase="isEverythingToCaps"
        :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0" />
      </v-col>
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0"
        label="In Care of 2" v-model="editedItem.name2"
        v-uppercase="isEverythingToCaps"
        :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0" />
      </v-col>
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0 mt-n1"
        label="Address 1" v-model="editedItem.address1"
        v-uppercase="isEverythingToCaps" />
      </v-col>
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0 mt-n1"
        label="Address 2" v-model="editedItem.address2"
        v-uppercase="isEverythingToCaps" />
      </v-col>
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0 mt-n1"
        label="Address 3" v-model="editedItem.address3"
        v-uppercase="isEverythingToCaps" />
      </v-col>
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0 mt-n1"
        label="Address 4" v-model="editedItem.address4"
        v-uppercase="isEverythingToCaps" />
      </v-col>
      <v-col cols="4">
        <v-text-field class="input-text-size pa-0 mt-n1" :rules="rules"
          label="City" v-model="editedItem.city"
          v-uppercase="isEverythingToCaps" />
      </v-col>
      <v-col cols="4">
        <v-text-field class="input-text-size pa-0 mt-n1" :rules="rules"
          label="State" v-model="editedItem.state"
          v-uppercase="isEverythingToCaps" />
      </v-col>
      <v-col cols="4">
        <v-text-field class="input-text-size pa-0 mt-n1" label="Zip"
        v-model="editedItem.zip" :rules="rules" />
      </v-col>
      <v-col cols="4">
        <v-text-field class="input-text-size pa-0 mt-n1"
        label="Country" v-model="editedItem.country"
        v-uppercase="isEverythingToCaps" />
      </v-col>
    </v-row>
</template>

<script>
import {
  mapGetters,
} from 'vuex';
import InCareOfSetting from '../../common-utils/inCareOf.mixin';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import '../../../../assets/style.css';

export default {
  name: 'PickListAddressChangeDialog',
  mixins: [InCareOfSetting, GlobalToCaps],
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    rules() {
      return [
        // onky when there address1 then we need city, state, zip
        (v) => (!this.editedItem.address1 || !!v) || 'Required.',
        () => true,
      ];
    },
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'pickListAddressDialog',
    },
  },
};
</script>
